import Phaser from "phaser";
import { audioManager } from "../../audio/AudioManager";

export class Combat {
  private scene: Phaser.Scene;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  flashSprite(sprite: Phaser.GameObjects.Sprite, intensity = 0.8): void {
    this.scene.tweens.add({
      targets: sprite,
      alpha: 1 - intensity,
      duration: 50,
      yoyo: true,
    });
  }

  createExplosion(x: number, y: number, color = 0x00ff00): void {
    // Explosion particles
    for (let i = 0; i < 12; i++) {
      const particle = this.scene.add.circle(
        x,
        y,
        Phaser.Math.Between(2, 5),
        color,
      );
      const angle = (i / 12) * Math.PI * 2;
      const speed = Phaser.Math.Between(50, 150);

      this.scene.tweens.add({
        targets: particle,
        x: x + Math.cos(angle) * speed,
        y: y + Math.sin(angle) * speed,
        alpha: 0,
        scale: 0.1,
        duration: 500,
        onComplete: () => particle.destroy(),
      });
    }
  }

  createShipExplosion(x: number, y: number): void {
    for (let i = 0; i < 20; i++) {
      const particle = this.scene.add.circle(
        x,
        y,
        Phaser.Math.Between(3, 8),
        Phaser.Math.Between(0, 1) ? 0xff6600 : 0xffaa00,
      );
      const angle = Math.random() * Math.PI * 2;
      const speed = Phaser.Math.Between(100, 300);

      this.scene.tweens.add({
        targets: particle,
        x: x + Math.cos(angle) * speed,
        y: y + Math.sin(angle) * speed,
        alpha: 0,
        duration: 1000,
        onComplete: () => particle.destroy(),
      });
    }
  }

  applyKnockback(
    ship: Phaser.Physics.Arcade.Sprite,
    fromX: number,
    fromY: number,
    force = 200,
  ): void {
    const angle = Phaser.Math.Angle.Between(fromX, fromY, ship.x, ship.y);
    ship.setVelocity(Math.cos(angle) * force, Math.sin(angle) * force);
  }

  shakeCamera(): void {
    this.scene.cameras.main.shake(200, 0.01);
  }

  playExplosionSound(): void {
    audioManager.playExplosion();
  }

  playHitSound(): void {
    audioManager.playHit();
  }

  playGameOverSound(): void {
    audioManager.playGameOver();
  }
}
